export default "/images/vendor/flag-icons/flags/1x1/in.svg?28a6f7605d41970756b4c8c126ed5cfb";